(function(){
  var N=121, HOST='https://courageous-dasik-e78fd3.netlify.app/frames/';
  var url=function(i){return HOST+'frame-'+String(i+1).padStart(3,'0')+'.jpg'};
  var canvas=document.getElementById('ba-canvas'); if(!canvas) return;
  if(window.matchMedia('(max-width: 768px)').matches){document.getElementById('ba-scroll').style.display='none';document.getElementById('ba-mobile').style.display='block';return}
  var ctx=canvas.getContext('2d'), W=720, H=1083;
  var imgs=[], loaded=[], count=0, cur=-1;
  var bar=document.getElementById('ba-bar'), pct=document.getElementById('ba-pct'), loader=document.getElementById('ba-loader'), label=document.getElementById('ba-label');
  function draw(i){var im=imgs[i]; if(im&&loaded[i]) ctx.drawImage(im,0,0,W,H)}
  for(var i=0;i<N;i++){(function(i){var im=new Image(); im.src=url(i); im.onload=function(){loaded[i]=true;count++;var p=Math.round(count/N*100);if(bar)bar.style.width=p+'%';if(pct)pct.textContent=p+'%';if(i===0){draw(0);canvas.style.opacity=1}if(count===N&&loader)loader.style.display='none'};imgs[i]=im})(i)}
  var section=document.getElementById('ba-scroll');
  function tick(){
    var scrolled=window.scrollY-section.offsetTop;
    var range=section.offsetHeight-window.innerHeight;
    var prog=Math.max(0,Math.min(1,scrolled/range));
    var idx=Math.min(N-1,Math.floor(prog*N));
    if(idx!==cur){cur=idx;draw(idx);
      var mid=N*0.5;
      if(idx<mid-6){label.textContent='Before';label.style.opacity=1}
      else if(idx<mid){label.style.opacity=0}
      else if(idx<mid+6){label.textContent='After';label.style.opacity=0}
      else{label.style.opacity=1}
    }
    requestAnimationFrame(tick)
  }
  requestAnimationFrame(tick)
})();
